import React, { useState } from 'react';
import { Plus } from 'lucide-react';
export interface NoteInputProps {
  /** Callback when a note is submitted */
  onSubmit: (note: string) => void;
  /** Placeholder text for the input */
  placeholder?: string;
  /** Optional data-id for component identification */
  'data-id'?: string;
}
/**
 * NoteInput - Ocean Design System
 *
 * A 40px height input field with integrated submit button.
 * Follows Ocean specs: ocean border, focus ring, primary action button.
 * Supports Enter key submission.
 */
export function NoteInput({
  onSubmit,
  placeholder = 'Add a note...',
  'data-id': dataId
}: NoteInputProps) {
  const [value, setValue] = useState('');
  const handleSubmit = () => {
    if (value.trim()) {
      onSubmit(value.trim());
      setValue('');
    }
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };
  return <div className="relative" data-id="element-2811">
      <label htmlFor="note-input" className="sr-only" data-id="element-2812">
        Add a note
      </label>
      <input id="note-input" type="text" placeholder={placeholder} className="w-full h-[40px] pl-4 pr-10 py-2 border border-[#CBD5E1] rounded-md text-[14px] bg-white focus:border-[#0EA5E9] focus:shadow-[0_0_0_3px_rgba(14,165,233,0.2)] outline-none transition-all duration-200" value={value} onChange={e => setValue(e.target.value)} onKeyPress={handleKeyPress} data-id="element-2813" />
      <button onClick={handleSubmit} disabled={!value.trim()} className="absolute right-2 top-1/2 -translate-y-1/2 text-[#0EA5E9] hover:text-[#0284C7] disabled:text-[#94A3B8] disabled:cursor-not-allowed transition-all duration-200" aria-label="Add note" data-id="element-2814">
        <Plus size={18} aria-hidden="true" data-id="element-2815" />
      </button>
    </div>;
}